import { useState } from 'react';
import { Box, Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { GOLD, DARK } from '../theme/theme';
import { FAQS } from '../data/constants';
import ScrollReveal from './ScrollReveal';

export default function FAQ() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box component="section" sx={{
      bgcolor: '#fffef8',
      py: { xs: 7, md: 10 }, px: '5%',
      borderTop: '1px solid rgba(0,0,0,0.06)',
    }}>
      <ScrollReveal>
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography sx={{ fontSize: '11px', color: GOLD, fontWeight: 700, letterSpacing: '0.30em', textTransform: 'uppercase', mb: 1 }}>FAQs</Typography>
          <Typography variant="h3" sx={{ fontFamily: "'Cinzel',Georgia,serif", fontWeight: 700, fontSize: { xs: '1.7rem', md: '2.2rem' }, color: DARK }}>
            Common <Box component="span" sx={{ color: GOLD }}>Questions</Box>
          </Typography>
        </Box>
      </ScrollReveal>

      <Box sx={{ maxWidth: 760, mx: 'auto' }}>
        {FAQS.map((f, i) => (
          <ScrollReveal key={i} delay={i * 70} y={16}>
            <Accordion expanded={expanded === i} onChange={(_, v) => setExpanded(v ? i : false)}
              sx={{
                mb: 1, bgcolor: '#fff',
                border: `1px solid rgba(184,134,11,${expanded === i ? '.4' : '.15'})`,
                borderRadius: '8px !important',
                boxShadow: expanded === i ? '0 2px 16px rgba(184,134,11,0.10)' : 'none',
                transition: 'box-shadow 0.25s ease, border-color 0.25s ease',
                '&:before': { display: 'none' },
              }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: GOLD }} />}
                sx={{ fontWeight: 600, color: expanded === i ? GOLD : DARK, fontSize: '14px' }}>
                {f.q}
              </AccordionSummary>
              <AccordionDetails sx={{ color: '#555', lineHeight: 1.8, fontSize: 14, borderTop: '1px solid rgba(184,134,11,0.10)' }}>{f.a}</AccordionDetails>
            </Accordion>
          </ScrollReveal>
        ))}
      </Box>
    </Box>
  );
}
